import { Component, Input, OnInit } from "@angular/core";
import { environment } from '@env/environment';
import { SharedService } from "@shared/services/shared.service";
import { IAdministrativeComplaintView } from "app/models/mainMenu/mainMenu";

import { AdminService } from "app/services/admin/admin.service";
import { BusinessService } from "app/services/business/business.service";
import { ComplaintService } from "app/services/complaint/complaint.service";



@Component({
  selector: 'complaint',
  templateUrl: './complaint.component.html',
  styleUrls: ['./complaint.component.scss']
})

export class ComplaintComponent implements OnInit {

  @Input() complaintId: string = '';

  businessId: number = 0;
  currentComplaint: IAdministrativeComplaintView = {} as IAdministrativeComplaintView;
  fileCount: number = 0;
  id: string = '0';
  currentTab: number = 0;

  constructor(
    private sharedService: SharedService,
    private businessService: BusinessService,
    private adminService: AdminService,
    private complaintService: ComplaintService
  ) {

  }

  ngOnInit(): void {
    this.currentTab = this.complaintService.complaintTab;
    this.getComplaint();
  }
  

  getComplaint() {
    this.complaintService.getComplaint(this.complaintService.complaintId).subscribe(
      (result) => {
        this.currentComplaint = result;
        this.businessId = this.currentComplaint.businessId;
        this.businessService.businessId = this.currentComplaint.businessId;
        this.complaintService.currentComplaint = this.currentComplaint;
        this.fileCount = this.currentComplaint.files != null ? this.currentComplaint.files.length : 0;
        this.tab();
      },
      error => {
        this.sharedService.toastr.error("Could not get Complaint Data:" + error.message);
      }
    );
  }

  // businessView() {
  // }

  gotoBusiness(businessId: number) {
    this.businessService.businessId = businessId;
    this.businessService.businessTab = 0;
    this.sharedService.doRedirect('business/business');
  }

  tab() {
    this.complaintService.updateTabs(this.currentTab);
  }

  updateFiles(){
    this.getComplaint();
  }


}